import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import '../css/HomeLarge.css';
import '../css/HomeMini.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';

class HomeLarge extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (


            <Card className="text-center bg-shell">
                <Card.Header className="text-center">
                    <br></br>
                </Card.Header>
                <Card.Body>
                    <Link to={this.props.Redirect} style={{ textDecoration: 'none' }}>
                        <div className="avatar avatar_shell bg-rgba-shell p-50 m-0 mb-1">
                            <i className={this.props.Icon} />                        </div>
                        <h2 className="text-bold-700" style={{ color: '#595959', margin: 'auto', fontSize: '18px', paddingTop: '10px' }}>{this.props.Title}</h2>
                    </Link>
                </Card.Body>
            </Card >


        );
    }
}

export default HomeLarge;